/* global axios */

import ApiClient from './ApiClient';

class SicSupportAPI extends ApiClient {
  constructor() {
    super('sic_support', { accountScoped: true });
  }

  chat({ message, images = [], history = [] }) {
    return axios.post(`${this.url}/chat`, { message, images, history });
  }

  history({ limit = 50, offset = 0 } = {}) {
    return axios.get(`${this.url}/history`, { params: { limit, offset } });
  }

  historyAccount({ limit = 50, offset = 0 } = {}) {
    return axios.get(`${this.url}/history_account`, {
      params: { limit, offset },
    });
  }

  syncKnowledge() {
    return axios.post(`${this.url}/sync_knowledge`);
  }

  check() {
    return axios.get(`${this.url}/check`);
  }

  listFiles() {
    return axios.get(`${this.url}/files`);
  }

  getFile(fileKey) {
    return axios.get(`${this.url}/files/${fileKey}`);
  }

  saveFile(fileKey, content) {
    return axios.put(`${this.url}/files/${fileKey}`, { content });
  }

  getConfig() {
    return axios.get(`${this.url}/config`);
  }

  updateConfig(config) {
    return axios.put(`${this.url}/config`, { config });
  }

  testEscalation() {
    return axios.post(`${this.url}/test_escalation`);
  }
}

export default new SicSupportAPI();
